import { render, staticRenderFns } from "./CoursesPlaces.vue?vue&type=template&id=48a48118"
import script from "./CoursesPlaces.vue?vue&type=script&lang=js"
export * from "./CoursesPlaces.vue?vue&type=script&lang=js"
import style0 from "./CoursesPlaces.vue?vue&type=style&index=0&id=48a48118&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports